var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_543_3701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.625C0 1.65977 0.784766 0.875 1.75 0.875H12.25C13.2152 0.875 14 1.65977 14 2.625V11.375C14 12.3402 13.2152 13.125 12.25 13.125H1.75C0.784766 13.125 0 12.3402 0 11.375V2.625ZM1.75 4.375V11.375H6.125V4.375H1.75ZM12.25 4.375H7.875V11.375H12.25V4.375Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_543_3701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboards);
export default __webpack_public_path__ + "static/media/dashboards.4ea5b2261f07d10f94e013176f3eb5aa.svg";
export { ForwardRef as ReactComponent };